import { useState, useEffect } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import Boat from "./Boat";

const Boats = () => {
  const [boats, setBoats] = useState();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getBoats = async () => {
      try {
        const response = await axiosPrivate.get("/api/v1/boats", {
          signal: controller.signal,
        });
        isMounted && setBoats(response.data.data.boats);
      } catch (err) {
        if (err?.response?.data?.statusCode === 404) {
          isMounted && setBoats([]);
        } else if (err.code !== "ERR_CANCELED") {
          console.error(err);
          navigate("/login", { state: { from: location }, replace: true });
        }
      }
    };

    getBoats();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [axiosPrivate, location, navigate]);

  return (
    <article>
      <h2>Select boat:</h2>
      {boats?.length ? (
        <ul>
          {boats.map((boat, i) => (
            <Boat key={i} boat={boat}></Boat>
          ))}
        </ul>
      ) : (
        <p>No boats to display</p>
      )}
    </article>
  );
};

export default Boats;
